import { NgFor, NgIf } from '@angular/common';
import { Component, Input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { DynamicModule } from 'ng-dynamic-component';
import { StoryblokDirective } from 'src/app/directive/storyblok.directive';

@Component({
  selector: 'app-page',
  standalone: true,
  imports: [NgFor, NgIf, RouterModule, DynamicModule, StoryblokDirective],
  templateUrl: './page.component.html',
  styleUrls: ['./page.component.scss'],
})
export class PageComponent {
  components: any;

  constructor() {
    import('src/app/storyblok/components').then((cp) => {
      this.components = cp.Components;
    });
  }

  @Input() _uid!: string;
  @Input() component!: string;
  @Input() metatags: any;
  @Input() body!: any[];
  @Input() _editable!: string;

  trackByFn(index: number, item: any): any {
    return item._uid; // or another unique identifier for your components
  }
}
